import { TemplatePage } from './types';

const linkedinPage: TemplatePage = {
  header: {
    color: '#CAD0D0',
    icon: 'images/video-templates/linkedin.jpg',
    title: 'LinkedIn Video Templates Collection',
    title_meta: '300+ Free Editable LinkedIn Video Templates',
    description_meta:
      'Create top-notch business videos with Wave.video’s collection of customizable LinkedIn video templates.',
    description:
      'Create top-notch business videos with our collection of customizable LinkedIn video templates. Get the most ' +
      'out of your LinkedIn video marketing efforts.'
  },
  footer: {
    category: 'LinkedIn',
    description:
      'Creating engaging video content for social media has never been more enjoyable and hassle-free thanks to ' +
      'Wave.video’s collection of customizable LinkedIn video templates. Choose a template that fits your business, ' +
      'customize it to match your branding, and download the result to your computer, embed it on your website, or ' +
      'share it directly on a social platform of your choice. Fast and easy!'
  },
  content: [
    {
      type: 'templates',
      title: 'LinkedIn video templates',
      search: {
        name: 'linkedIn'
      }
    },
    {
      type: 'stocks',
      title: 'linkedIn',
      search: { name: 'linkedIn' }
    },
    { type: 'calendar' }
  ]
};

export default linkedinPage;
